
<main>
	<link rel="preconnect" href="https://fonts.gstatic.com">
	<link href="https://fonts.googleapis.com/css2?family=Jost:wght@900&display=swap" rel="stylesheet"> 

	<h1 class="animate__animated animate__tada">TIC <br>TAC<br> TOE</h1>

	<input type="text" bind:value={name} placeholder="NAME" class="input center" style="margin-top: 40px;">
	<div class="choose">

		<button on:click={create_room} class="button is-success left hvr-grow">Create Room</button>

		
		<div class="right">
			<input type="text" bind:value={join_id} placeholder="ROOM ID" class="input right-input">
			
			<button on:click={join_room} class="button is-info hvr-grow">Join Room</button>
		</div>
	</div>

	<p id="credits"> Made with ❤️ by <a href="https://github.com/smorrin28/">smorrin</a> and <a href="https://github.com/JGStyle/">JGStyle</a>.</p>
</main>

<script>
	import axios from 'axios'
	import 'bulma/css/bulma.css'
	import 'animate.css'
	import name_store from './name_store.js'
	import { push } from 'svelte-spa-router'

	let join_id = ""
	let name = ""
	const url = "https://tic-tac-toe-online-backend.herokuapp.com"

	function get_name(){
		if(name === ""){
			return "Rick Astley"
		} else {
			return name
		}
	} 

	async function create_room() {
		try {
			join_id = (await axios.post(url + '/new')).data.id
			join_room()
		} catch {
			alert("Ein Fehler ist aufgetreten")
		}
	}

	function join_room() {
		name_store.set(get_name())
		push(`/${join_id}`)
	}

	
</script>


<style>

	main {
		text-align: center;
		padding: 1em;
		max-width: none;
		width: 100vw;
		height: 100vh;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	:global(body){
		background-color: rgb(26, 26, 26);
	}

	h1 {
		color: #ffffff;
		
		text-transform: uppercase;
		font-size: 6em;
		font-weight: 900;
		font-family: 'Jost', sans-serif;

		line-height: 80%;
	}

	.right {
		width: 42%;
		display: flex;
		flex-direction: row;
		
	}

	.right-input {
		width: 45% !important;
	}

	.choose {
		display: flex;
		flex-direction: row;
		margin-top: 40px;
		justify-content: space-around;
		flex-wrap: wrap;
	}

	.center {
		width: 40%;
	}

	input, ::placeholder {
    	background-color:rgb(26, 26, 26);
		color: white !important;
	}	

	#credits {
		position: absolute;
		bottom: 10px;
	}


	@media (max-width: 500px) {
		main {
			max-width: 240px;
		}
		.right-input {
			width:100% !important;
		}
		.choose {
			display:inline;
		}
		.center {
			width: 100%;
		} 
		.right {
			margin-top: 20px;
		}
	}
	@media (prefers-color-scheme: light) {
		h1 {
			color: #000000;
		}
		:global(body){
		background-color: white;
		}
		:global(html){
		background-color: white;
		}
		input, ::placeholder {
    	background-color: white;
		color: grey !important;
		}	
		main {
			background-color: white;
		}	
	}

	.hvr-grow {
    display: inline-block;
    vertical-align: middle;
    transform: translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    backface-visibility: hidden;
    -moz-osx-font-smoothing: grayscale;
    transition-duration: 0.3s;
    transition-property: transform;
	}

	.hvr-grow:hover,
	.hvr-grow:focus,
	.hvr-grow:active {
		transform: scale(1.1);
	}
</style>